import { FC, MouseEvent, useState } from "react";
import { ContentfulNavigationItem } from "../lib/contentfulTypes";
import MobileMenuDrawer from "./MobileMenuDrawer";

interface MobileMenuProps {
  brand: string;
  isOpen: boolean;
  items: ContentfulNavigationItem[];
  logoUrl?: string;
  onClose: () => void;
  supportNav: ContentfulNavigationItem[];
}

const MobileMenu: FC<MobileMenuProps> = ({ 
  brand,
  isOpen, 
  items, 
  logoUrl, 
  onClose,
  supportNav = []
}) => {
  const [secondLevelRoot, setSecondLevelRoot] = useState<ContentfulNavigationItem|undefined>();
  const [thirdLevelRoot, setThirdLevelRoot] = useState<ContentfulNavigationItem|undefined>();

  const handleItemClick = (e: MouseEvent, item: ContentfulNavigationItem, level: number) => {
    if (item.fields.subItems) {
      e.preventDefault();

      if (level == 1) {
        setSecondLevelRoot(item);
      }

      if (level == 2) {
        setThirdLevelRoot(item);
      }
    }
  }

  const handleClose = () => {
    setSecondLevelRoot(undefined);
    setThirdLevelRoot(undefined);
    onClose();
  }

  return (
    <>
      <MobileMenuDrawer 
        brand={brand}
        isOpen={isOpen}
        items={items}
        level={1}
        logoUrl={logoUrl}
        onCloseButtonClick={handleClose}
        onItemClick={handleItemClick}
        supportNav={supportNav}
      />
      <MobileMenuDrawer 
        backButtonLabel="All"
        brand={brand}
        isOpen={secondLevelRoot ? true : false}
        // @ts-ignore
        items={secondLevelRoot?.fields.subItems || []}
        level={2}
        onBackButtonClick={() => setSecondLevelRoot(undefined)}
        onCloseButtonClick={handleClose}
        onItemClick={handleItemClick}
        rootItem={secondLevelRoot}
      />
      <MobileMenuDrawer 
        backButtonLabel={secondLevelRoot?.fields.title}
        brand={brand}
        isOpen={thirdLevelRoot ? true : false}
        // @ts-ignore
        items={thirdLevelRoot?.fields.subItems || []}
        level={3}
        onBackButtonClick={() => setThirdLevelRoot(undefined)}
        onCloseButtonClick={handleClose}
        onItemClick={handleItemClick}
        rootItem={thirdLevelRoot}
      />
    </>
  );
}

export default MobileMenu;